import React, {} from "react";
import "./menu.css";
// Components
import ButtonBack from "../../common/buttonBack";
import ButtonSave from "../../common/buttonSave";

const MaintenanceViewMenu = ({ 
  config, 
}) => {

  return (
      <div id="maintenance-form-menu">
        <ButtonBack config={config.buttonBack} />
        <ButtonSave config={{...config.buttonSave, marginLeft: "5px" }} />
      </div>
  );
};

export default MaintenanceViewMenu;
